module.exports = __webpack_public_path__ + "static/sport/footer1.96ba34b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/footer1.png
// module id = cfaY
// module chunks = 0